import { getServicePage } from "../config/content.js";
import { serviceRoute } from "../config/paths.js";
import { createNav, bindNav } from "./components/Nav.js";
import { createServicesBannerSection } from "./sections/services/ServicesBanner.js";
import { createServicesApproachSection } from "./sections/services/ServicesApproach.js";
import { createTestimonialsSection } from "./sections/Testimonials.js";
import { createServicesFaqsSection } from "./sections/services/ServicesFaqs.js";
import { createServicesInsightsSection } from "./sections/services/ServicesInsights.js";
import { createContactSection } from "./sections/Contact.js";
import { createStaffAugmentationFormSection } from "./sections/services/StaffAugmentationForm.js";
import { createFooter } from "./sections/Footer.js";
import { bindServicesMotion } from "./ServicesMotion.js";

export function mountServicesPage(root, slug = "web-development") {
  const pageContent = getServicePage(slug);
  const isStaffAug = slug === "staff-augmentation";

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--services";

  const nav = createNav();

  contentLayer.append(
    nav,
    createServicesBannerSection(pageContent.banner, {
      title: pageContent.title,
      slug,
    }),
    createServicesApproachSection(pageContent.approach),
    createTestimonialsSection({
      data: pageContent.testimonials,
      id: "testimonials",
    }),
    createServicesFaqsSection(pageContent.faqs, { serviceRail: true, activeSlug: slug }),
    createServicesInsightsSection(pageContent.insights)
  );

  if (isStaffAug) {
    contentLayer.append(createStaffAugmentationFormSection());
  } else {
    contentLayer.append(createContactSection());
  }

  contentLayer.append(createFooter());

  root.append(canvasLayer, contentLayer);
  bindServicesMotion(contentLayer);

  const pageHref = serviceRoute(slug);
  const insightsHref = serviceRoute(slug, "insights");
  const contactHref = serviceRoute(slug, "contact");
  const requestHref = serviceRoute(slug, "request");

  const updateNavActive = bindNav(nav, {
    page: "service",
    serviceSlug: slug,
    sectionMap: {
      banner: pageHref,
      approach: pageHref,
      testimonials: pageHref,
      faqs: pageHref,
      insights: insightsHref,
      ...(isStaffAug ? { request: requestHref } : { contact: contactHref }),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: pageContent.documentTitle,
    sections: {
      banner: contentLayer.querySelector("#banner"),
      approach: contentLayer.querySelector("#approach"),
      testimonials: contentLayer.querySelector("#testimonials"),
      faqs: contentLayer.querySelector("#faqs"),
      insights: contentLayer.querySelector("#insights"),
      ...(isStaffAug
        ? { request: contentLayer.querySelector("#request") }
        : { contact: contentLayer.querySelector("#contact") }),
    },
  };
}
